export const LOAD_PPQ_REPORT = "LOAD_PPQ_REPORT";
export const LOAD_PPQ_REPORT_SUCCESS = "LOAD_PPQ_REPORT_SUCCESS";
export const VIEWED_PPQ_REPORT = "VIEWED_PPQ_REPORT";
